import { render, staticRenderFns } from "./ProductsSearchPage.vue?vue&type=template&id=a52825be&scoped=true&"
import script from "./ProductsSearchPage.vue?vue&type=script&lang=ts&"
export * from "./ProductsSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsSearchPage.vue?vue&type=style&index=0&id=a52825be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52825be",
  null
  
)

export default component.exports